// Inventory Outlets Getters

export const getOutletsList = state => {
  return state.outletsList
}

export const getOutletInfo = state => {
  return state.outletInfo
}

export const getFullOutletsList = state => {
  return state.fullOutletsList
}

export const getFullReportOutletsList = state => {
  let list = state.fullOutletsList
  list.unshift({ value: 0, text: 'All' })
  return list
}
